module.exports = __webpack_public_path__ + "img/auth-back-arrow.6091f3d6.svg";